import { IconButton, Switch } from '@mui/material'
import QueryFilter from 'components/Table/components/QueryFilter'

const renderFilter = (info) => <QueryFilter key='FilterInput' {...info} />

export const getAutoTopUpColumns = (exchangesMap, toggleRule, setSelectedNetwork, onDelete) => [
  {
    Header: 'Update',
    accessor: '_update-action',
    Cell: ({ row }) => {
      return (
        <IconButton
          onClick={() => {
            setSelectedNetwork({ ...row.original })
          }}
          size={'small'}
          style={{ margin: '0 8px', color: '#1976d2' }}
        >
          <i className='fas fa-edit' />
        </IconButton>
      )
    },
    Filter: () => null,
  },
  {
    Header: 'Delete',
    accessor: '_delete-action',
    Cell: ({ row }) => (
      <IconButton
        onClick={() => onDelete(row.original.id)}
        size={'small'}
        style={{ margin: '0 8px', color: '#d32f2f' }}
      >
        <i className='fas fa-trash' />
      </IconButton>
    ),
    Filter: () => null,
  },
  {
    Header: 'Enabled',
    accessor: 'enabled',
    Cell: ({ value, row }) => {
      return <Switch checked={value} onChange={() => toggleRule(row.original.id, value)} />
    },
    Filter: renderFilter,
  },
  {
    Header: 'ID',
    accessor: 'id',
    Filter: renderFilter,
  },
  {
    Header: 'Expected Amount',
    accessor: 'expected_amount',
    Filter: renderFilter,
  },

  {
    Header: 'Min threshold',
    accessor: 'min_threshold',
    Filter: renderFilter,
  },
  {
    Header: 'Exchange',
    accessor: 'exchange',
    Cell: ({ value }) => exchangesMap[value] || value,
    Filter: renderFilter,
  },
  {
    Header: 'Left Asset',
    accessor: 'left_asset',
    Filter: renderFilter,
  },
  {
    Header: 'Right Asset',
    accessor: 'right_asset',
    Filter: renderFilter,
  },
]
